import { CardContentType } from './card-item.model';
import { Deserializable } from './deserializable.model';
import { JsonObject } from './json-object.model';
import { LocalResourceLocation } from './local-resource-location.model';
import { UserCardPreference, UserCardState } from './user-card-state.model';

export class LocalResourcesProgram implements Deserializable<JsonObject, LocalResourcesProgram> {
  constructor(
    public description?: string,
    public programName?: string,
    public id?: string,
    public providerName?: string,
    public offices?: LocalResourceLocation[],
    public nearestOffice?: LocalResourceLocation,
    public email?: string,
    public websiteUrl?: string,
    public updateDate?: string,
    public preference?: UserCardPreference,
    public rules?: string[],
    public contentId?: string,
    public isInViewport = false,
    public userState?: UserCardState,
    public hideFromUI = false,
    public contentType: CardContentType = CardContentType.localResource
  ) {}

  deserialize(input: JsonObject): LocalResourcesProgram {
    if (input == null) {
      return null;
    }
    this.description = input['description'];
    this.programName = input['name'] || input['programName'];
    this.id = input['program_numeric_id'] || input['id'];
    this.providerName = input['provider_name'] || input['providerName'];
    if (Array.isArray(input['offices'])) {
      this.offices = input['offices'].map((office) => new LocalResourceLocation().deserialize(office));
    }
    this.nearestOffice = this.offices?.[0];
    this.email = this.offices?.[0].email;
    this.websiteUrl = input['website_url'] || input['websiteUrl'];
    this.updateDate = input['updateDate'] || (input['update_date'] ? input['update_date'].split('@')[0] : null);
    this.preference =
      input['preference']?.endsWith?.('_more') || input['preference'] === UserCardPreference.MORE
        ? UserCardPreference.MORE
        : UserCardPreference.NEUTRAL;
    this.rules = input['rules'];
    this.contentId = input['contentId'] || input['content_id'];
    this.isInViewport = input['isInViewport'];
    this.userState = input['userState'] ? new UserCardState().deserialize(input['userState']) : null;
    this.hideFromUI = input['hideFromUI'];
    this.contentType = (input['contentType'] as CardContentType) || CardContentType.localResource;
    return this;
  }
}
